import type { SerializedHorizontalRuleNode } from '../../../../../nodeTypes.js'
import type { JSXConverters } from '../types.js'
export const HorizontalRuleJSXConverter: JSXConverters<SerializedHorizontalRuleNode> = {
  horizontalrule: <hr />,
}
